import { Pipe, PipeTransform } from '@angular/core';

import { CONTATOS_INICIATIVAS } from '../contato-iniciativa';

@Pipe({
    name: 'contatoIniciativaIcon'
})
export class ContatoIniciativaIconPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = CONTATOS_INICIATIVAS.findIndex(iniciativa => iniciativa.id === value);
        if (index > -1) {
            return CONTATOS_INICIATIVAS[index].iconClass;
        }

        return '';
    }
}
